'use client';

import { useMemo, useState } from 'react';

import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

import { MIXPANEL_APP_FEATURES } from '@/shared/constants/mixpanel-events';

import {
	ONBOARDING_SCREEN_HEADERS,
	OnboardingScreen,
	OnboardingView,
} from '../../constants/user-onboarding-constants';
import UserOnboarding from '../entry/user-onboarding';
import { BaseOnboardingModal } from './base-onboarding-modal';

interface UserOnboardingModalProps {
	open: boolean;
	onComplete?: (data: { userName: string; workspaceName: string; workspacePhoto?: string }) => void;
	defaultScreen?: OnboardingScreen;
	allowedScreens?: OnboardingScreen[];
}

export function UserOnboardingModal({ open, onComplete }: UserOnboardingModalProps) {
	const [currentScreen, setCurrentScreen] = useState<OnboardingView>(OnboardingScreen.USER_NAME);

	const { title, description } = useMemo(
		() => ({
			title: ONBOARDING_SCREEN_HEADERS[currentScreen].title,
			description: ONBOARDING_SCREEN_HEADERS[currentScreen]?.description,
		}),
		[currentScreen]
	);

	return (
		<BaseOnboardingModal open={open}>
			<DialogHeader className="flex flex-col items-start">
				<DialogTitle className="text-2xl">{title}</DialogTitle>
				{description && <DialogDescription>{description}</DialogDescription>}
			</DialogHeader>

			<UserOnboarding
				onComplete={onComplete}
				skipLayout={true}
				onScreenChange={setCurrentScreen}
				source={MIXPANEL_APP_FEATURES.USER_ONBOARDING_VIA_MODAL}
			/>
		</BaseOnboardingModal>
	);
}
